import { ASSETS_PATH_PREFIX } from '../../helpers/electron';
import type { ThemeMode, ThemeVariantKeys } from '../../theme';

export const getPatternUrlByTheme = (themeMode?: ThemeMode, themeVariant?: ThemeVariantKeys) => {
    if (!themeMode || !themeVariant) return;

    return `${ASSETS_PATH_PREFIX}images/themVariants/${themeVariant}/chat_pattern_${themeMode}.svg`;
};
